import { translateSync } from "@opendash/i18n";
import { makeAutoObservable } from "mobx";
import { $framework } from "..";
export class UserInterfaceService {
    constructor(app) {
        this.servicesLoading = true;
        this.userDialogDisabled = false;
        this.userDialogOpen = false;
        this.notificationsDialogDisabled = false;
        this.notificationsDialogOpen = false;
        this.versionDialogDisabled = false;
        this.versionDialogOpen = false;
        this.languageDialogDisabled = false;
        this.languageDialogOpen = false;
        this.resetPWDialogOpen = false;
        this.sidebarVisible = false;
        this.sidebarOpen = false;
        this.sidebar = {
            available: false,
            open: false,
        };
        this.headerHeight = 0;
        this.headerWidth = 0;
        this.copyrightText = "";
        this.copyrightLink = "";
        this.imprint = "";
        this.tos = "";
        this.dataProtection = "";
        this.imprintTenant = "";
        this.tosTenant = "";
        this.dataProtectionTenant = "";
        makeAutoObservable(this);
        this.app = app;
    }
    get name() {
        var _a, _b;
        return ((_b = (_a = this.app.config) === null || _a === void 0 ? void 0 : _a.manifest) === null || _b === void 0 ? void 0 : _b.name) || "?";
    }
    get version() {
        var _a, _b;
        return "v" + (((_b = (_a = this.app.config) === null || _a === void 0 ? void 0 : _a.manifest) === null || _b === void 0 ? void 0 : _b.version) || "0.0.0");
    }
    get primaryColor() {
        return this.app.ui.primaryColor;
    }
    setServicesLoading(value) {
        this.servicesLoading = value;
    }
    showUserDialog() {
        this.userDialogOpen = true;
    }
    hideUserDialog() {
        this.userDialogOpen = false;
    }
    showNotificationsDialog() {
        this.notificationsDialogOpen = true;
    }
    hideNotificationsDialog() {
        this.notificationsDialogOpen = false;
    }
    showVersionDialog() {
        this.versionDialogOpen = true;
    }
    hideVersionDialog() {
        this.versionDialogOpen = false;
    }
    showLanguageDialog() {
        this.languageDialogOpen = true;
        this.hideUserDialog();
    }
    showResetPWDialog() {
        console.log("True");
        this.resetPWDialogOpen = true;
        this.hideUserDialog();
    }
    hideResetPWDialog() {
        console.log("false");
        this.resetPWDialogOpen = false;
    }
    hideLanguageDialog() {
        this.languageDialogOpen = false;
    }
    updateSidebar(sidebar) {
        Object.assign(this.sidebar, sidebar);
    }
    setHeaderSize(height, width) {
        try {
            this.headerHeight = height;
            this.headerWidth = width;
            document.documentElement.style.setProperty("--opendash-header-height", height + "px");
            document.documentElement.style.setProperty("--opendash-header-width", width + "px");
        }
        catch (error) {
            console.error(error);
        }
    }
    setLinks(links) {
        Object.assign(this, links);
    }
    message(type, msg, timeout) {
        msg = translateSync(msg);
        switch (type) {
            case "success":
                return $framework.antd_msg.success(msg, timeout);
            case "warning":
                return $framework.antd_msg.warning(msg, timeout);
            case "error":
                return $framework.antd_msg.error(msg, timeout);
            default:
            case "info":
                return $framework.antd_msg.info(msg, timeout);
        }
    }
}
//# sourceMappingURL=UserInterfaceService.js.map